/**
 * Service: order
 */
angular.module('acme.common.service.order', [])
.service('OrderService', [function() {

    return {

      model: {},
      stored: false,

      types: {
        "Event": "Event",
        "Inventory": "Add-on",
        "Combo": "Event",
        "ComboInventory": "Add-on",
        "RebookingFee": "Fee",
        "MembershipPurchase": "New Purchase",
        "MembershipRenewal": "Renewal",
        "MembershipUpgrade": "Upgrade",
        "MembershipDowngrade": "Downgrade",
        "MembershipCancel": "Cancellation",
        "MembershipPostTermRenewal": "Post Term Renewal",
        "MembershipRejoin": "Rejoin",
        "MembershipRenewalUpgrade": "Renewal Upgrade",
        "MembershipPostTermRenewalUpgrade": "Post Term Renewal Upgrade",
        "MembershipRejoinUpgrade": "Rejoin Upgrade",
        "MembershipPostTermRenewalDowngrade": "Post Term Renewal Downgrade",
        "MembershipRejoinDowngrade": "Rejoin Downgrade",
        "MembershipRenewalDowngrade": "Renewal Downgrade",
        "MembershipPurchaseConversion": "Purchase Conversion",
        "MembershipReplacement": "Replacement",
        "Donation": "Donation"
      },

      init: function() {
        return true;
      },

      store: function(order) {
        this.stored = true;
        this.model = order;
      },

      fetch: function() {
        return (this.stored) ? this.model : false;
      },

      clear: function() {
        this.model = {};
        this.stored = false;
        return true;
      },

      getItemType: function(type, subType) {

        var r;

        if (type === 'Inventory' || type === 'ComboInventory') {
          r = 'Add-on';
        }else if (type === 'Event' || type === 'Combo') {
          r = 'Ticket';
        }else if (type === 'RebookingFee' || type === 'Fee') {
          r = 'Fee';
        }else if (type && (type.toLowerCase().indexOf('membership') > -1)) {
          if (subType) {
            r = this.types[type] || 'Membership';
          } else {
            r = 'Membership';
          }

        }

        return r;

      }

    };

}]);